import React from "react";
import SEOHead from "../components/SEOHead";
import Header from "./Header";
import Footer from "./Footer";
import Breadcrumb from "./Breadcrumb";
import BangGiaPricing from "./product/BangGiaPricing";
import Cta from "./product/OpenApiCta";
import Testimonial from "./home/Testimonial";

const BangGia = () => (
  <>
    <SEOHead pageKey="bangGia" />
    <Header />
    <Breadcrumb />
    <BangGiaPricing />
    <Cta />
    <Testimonial />
    <Footer />
  </>
);

export default BangGia;
